export default __webpack_public_path__ + "static/media/404.4e83b5c6.svg";